import { gql } from '@apollo/client'

export const TOPICS_QUERY = gql`
  query dashboardModal_getSuggest_topics($languages: [TaxonomyLanguages!], $limit: Int! = 5, $term: String!) {
    getSuggest(term: $term) {
      topics(limit: $limit, languages: $languages) {
        id
        language
        title

        category {
          topicGroupId
          title
        }
      }
    }
  }
`

export const SUBTOPICS_QUERY = gql`
  query dashboardModal_getSuggest_subtopics($languages: [TaxonomyLanguages!], $limit: Int! = 5, $term: String!) {
    getSuggest(term: $term) {
      subtopics(limit: $limit, languages: $languages) {
        id
        language
        title

        topic {
          title
        }
      }
    }
  }
`

export const SAVED_POST_SEARCHES_QUERY = gql`
  query dashboardModal_getSuggest_savedPostSearches($limit: Int! = 5, $term: String!) {
    getSuggest(term: $term) {
      savedPostSearches(limit: $limit) {
        id
        name
        query
      }
    }
  }
`
